export default defineAppConfig({
  ui: {
    primary: 'indigo',
    gray: 'cool',
  },
} as const)
